export function evaluationStyleText(style) {
    return `${style.label} in ${style.matching} of the last ${style.considered}`;
}
